import { getItems } from '../util/recommendations.js';

export function loadCustomCarousel() {
  const customCarousel = document.getElementById('custom-carousel');
  if (!customCarousel) {
    return;
  }

  const familiesDataScript = document.getElementById('custom-carousel-families-data');
  try {
    if (familiesDataScript) {
      const familiesData = JSON.parse(familiesDataScript.textContent);
      if (!familiesData || familiesData === '') {
        throw new Error('Custom carousel families data is null or empty');
      }

      const items = getItems(familiesData);
      customCarousel.items = items;
    }
  } catch (error) {
    console.error('Error parsing custom carousel families data:', error);
  }
}
